import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router';
import './Statement.css'
import get_statment from '../../context/action/statment/get_statment';
import Statment_template_1 from '../../component/statment_template/Statment_template_1';

const Statment = () => {
    const { statment_number } = useParams();
    const [isLoading,setisLoading]=useState(true);
    const [notFound,setnotFound]=useState(false);
    const [data,setData]=useState([]);

    useEffect(()=>{
        get_statment(statment_number).then((res)=>{
            if(res?.status!='ok'||res?.data.length<=0){
                setnotFound(true);
            }else{
                setnotFound(false);
                setData(res.data);
            }
            setisLoading(false);
        }).catch(err=>{
            setnotFound(true);
            setisLoading(false);
        });
    },[statment_number]);

    if(isLoading){
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p className="loading-text">Loading data...</p>
            </div>
        )
    }

    if(notFound){
        return (
            <div className="not-found-container">
                <div className="not-found-content">
                    <i className="not-found-icon">❌</i>
                    <h1 className="not-found-title">Statement Not Found</h1>
                    <p className="not-found-message">The statement you're looking for could not be found.</p>
                    <button onClick={() => window.history.back()} className="back-button">
                        Go Back
                    </button>
                </div>
            </div>
        )
    }

    // Render the template (currently uses static demo data inside)
    return (
        <div className='min-h-screen bg-gray-200 flex justify-center'>
            <div className='w-11/12 lg:w-6/12 my-14'>
                <Statment_template_1 {...data[0]} />
            </div>
        </div>
    )
}

export default Statment